<template>
<div class='details'>
  <table class='members-table'>
    <tr>
      <th>
        <!-- 添加成员下拉框 -->
        <!-- <el-button type="text" theme='info' v-if="showAddMembers" v-on:click="addMembers" style="padding:0;">添加成员</el-button> -->
        <span>所有成员</span>
        <!-- <el-dropdown menu-align="start" class="add-members">
          <span class="el-dropdown-link">添加成员<i class="ppj-icon-down-dir"></i></span>
          <el-dropdown-menu class="sub-menu" slot="dropdown">
            <el-dropdown-item>
              <a class="sub-menu-item">单个添加</a>
            </el-dropdown-item>
            <el-dropdown-item>
              <a class="sub-menu-item">批量添加</a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </th>
      <th style="width: 10%">角色</th>
      <th style="width: 10%">{{$t('common.project')}}</th>
      <th style="width: 20%">部门</th>
      <th style="width: 10%">账号状态</th>
      <th style="width: 15%" v-if="canDo('edit_members') && !tbcMode">操作</th>
    </tr>
    <tr v-if="loading">
      <td class='loading-cell' colspan="10">
        <div class='spinner-wrapper'>
          <i class='ppj-icon-spinner' />
        </div>
      </td>
    </tr>
    <tr v-for="member in members" :key="member.id" v-else>
      <td class='profile' v-once>
        <div class='img avatar' :style="{backgroundImage: 'url('+member.user.profile_picture+')'}"></div>
        <div class='nickname'>{{member.user.nickname}}</div>
        <div class='email'>{{member.user.email}}</div>
      </td>
      <td>{{$t(`roles.${member.role}`)}}</td>
      <td>{{member.projects_count}}</td>
      <td>{{member.department}}</td>
      <td>{{$t(`memberState.${member.state}`)}}</td>
      <td v-if="canDo('edit_members') && !tbcMode">
        <el-button type='text' theme='info' @click="editMember(member)">编辑</el-button>
        <el-button type='text' theme='danger' @click="removeMember(member.id)" v-if="member.role !== 'owner'">删除</el-button>
      </td>
    </tr>
  </table>
  <el-pagination small layout="prev, pager, next" :total="totalItems" :page-count="totalPages" :current-page.sync="currentPage" :page-size="pageSize" @current-change="fetch">
  </el-pagination>
</div>
</template>

<i18n>
{
  "zh-cn": {
    "roles": {
      "owner": "创建者",
      "admin": "管理员",
      "member": "普通成员"
    },
    "memberState": {
      "accepted": "正常",
      "awaiting": "未激活",
      "denied": "已拒绝"
    }
  }
}
</i18n>

<style lang='scss' scoped>
.details {
    padding-top: $margin-base;
    .members-table {
        .add-members {
            .el-dropdown-link {
                color: $color-info;
                cursor: pointer;
            }
        }
    }

    .el-pagination {
        margin-top: $margin-base;
        text-align: center;
    }
}

.sub-menu .sub-menu-item {
    padding: 0.6em 1em;
    &:hover {
        color: darken($color-info, 5%);
        background-color: $color-info-bg;
    }
}
</style>

<script>
import EditMemberDialog from './edit_member.dialog'
import { createDialog } from '@/assets/scripts/dialog'
// let messageListener = null

export default {
  data() {
    return {
      members: [],
      currentPage: 1,
      totalPages: 1,
      totalItems: 1,
      pageSize: 1,
      loading: false,
      editMemberDialog: createDialog(EditMemberDialog)
    }
  },
  computed: {
    showAddMembers() {
      // display show members when
      // 1. the user has authenticated to add members
      // 2. currently only open to TBC
      return this.tbcMode && window.postMessage
    }
  },
  methods: {
    fetch() {
      let vm = this
      vm.loading = true
      vm.$store.dispatch('organization/members', {
        orgId: vm.organization.id,
        page: vm.currentPage || 1
      }).then(res => {
        // vm.currentPage = res.data.current_page
        vm.members = res.data.list
        vm.totalPages = res.data.total_pages
        vm.totalItems = res.data.total_items
        vm.pageSize = res.data.page_size
        vm.loading = false
      })
    },
    removeMember(memId) {
      let vm = this
      vm.$confirm('确定从组织中移除该成员？', '删除成员？', {
        cancelButtonClass: 'el-button--text',
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: vm.$t('common.buttons.cancel'),
        confirmButtonText: vm.$t('common.buttons.ok')
      }).then(_ => {
        vm.$store.dispatch('organization/removeMember', {
          orgId: vm.organization.id,
          memId: memId
        }).then(_ => {
          // 重新载入当前页面
          vm.fetch()
        })
      }).catch(_ => {})
    },
    editMember(member) {
      let vm = this
      vm.editMemberDialog({
        member: JSON.parse(JSON.stringify(member)),
        orgId: vm.organization.id,
        memId: member.id,
        success: () => {
          vm.fetch()
        }
      })
    }
  },
  mounted() {
    this.fetch()
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?0fea8fc2